export const EstateFormKey = {
  DIRECTIONS_AND_AUTHORIZATION: 'directions_and_authorization',
  ISP_1200: 'isp_1200',
  ISP_1300: 'isp_1300',
  ISP_1201: 'isp_1201',
  ISP_3104: 'isp_3104',
  NOTICE_OF_DEATH_TO_CRA: 'notice_of_death_to_cra',
  NOTICE_OF_DEATH_TO_EQUIFAX: 'notice_of_death_to_equifax',
  NOTICE_OF_DEATH_TO_TRANSUNION: 'notice_of_death_to_transunion',
  TAX_AUTHORIZATION_FORM: 'tax_authorization_form',
  NOTICE_TO_FRANCHISE_TAX_BOARD: 'notice_to_franchise_tax_board',
  NOTICE_TO_DEPARTMENT_OF_HEALTH_CARE_SERVICES: 'notice_to_department_of_health_care_services',
  NOTICE_TO_VICTIMS_COMPENSATION_BOARD: 'notice_to_victims_compensation_board',
  DE_157: 'de_157',
  NOTICE_OF_DEATH_TO_EXPERIAN: 'notice_of_death_to_experian',
  FORM_56_NOTICE_CONCERNING_FIDUCIARY_RESPONSIBILITY:
    'form_56_notice_concerning_fiduciary_responsibility',
  DE_160: 'de_160',
  DE_161_ATTACHMENT_1: 'de_161_attachment_1',
  DE_161_ATTACHMENT_2: 'de_161_attachment_2',
  DE_161_ATTACHMENT_1_V2: 'de_161_attachment_1_v2',
  DE_161_ATTACHMENT_2_V2: 'de_161_attachment_2_v2',
  MC_025: 'mc_025',

  // Mock EstateFormKey for adding extra documents
  COVER_LETTER: 'cover_letter'
};
